import React from 'react';
import { physicsCalculators_En } from '../ConstantsEN';
import SharedHelmet from '../Helmet';
const TITLE = 'Physics Calculators - Free Tools to Calculate Time, Cubic Meter, Iron Mass, Lenses Power, Water Mass, and Gas Volume';
const DESCRIPTION = 'Explore a collection of free physics calculators, including calculators for time of arrival, cubic meter calculation, iron mass, lenses power, water mass, and gas volume.';
const KEYWORDS = 'Physics calculators, Free calculators, Time of arrival calculator, Cubic meter calculator, Iron mass calculator, Lenses power calculator, Water mass calculator, Gas volume calculator';
const NOTE = 'If you know or wish to add other calculators, please contact us via email at info@do-calculate.com. We would be happy to add them! :)';
const OG_URL = 'https://do-calculate.com/en/physics-calculators';
function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION}</p>
                </div>
                <div className="alert alert-info" role="alert">
                    <u><p>{NOTE}</p></u>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr>
                        <th >Calculator</th>
                        <th >Description</th>
                    </tr>
                </thead>
                <tbody>
                    {physicsCalculators_En.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}><h2 style={{ fontSize: '14px' }}>{calculator.name}</h2></a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
